// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {animate, query, stagger, style, transition, trigger} from "@angular/animations";
import {Translations} from "@translations";
import {fadeInOnEnterAnimation} from "angular-animations";
import {TranslationKey} from "@models";

@Component({
	selector: "sim-admin-settings-scroll-entries-con",
	templateUrl: "./sim-admin-settings-scroll-entries-con.component.html",
	styleUrl: "./sim-admin-settings-scroll-entries-con.component.scss",
	animations: [
		fadeInOnEnterAnimation({duration: 175}),
		trigger("listStagger", [
			transition("* <=> *", [
				query(
					":enter",
					[
						style({opacity: 0, transform: "translateY(-15px)"}),
						stagger(
							"50ms",
							animate(
								"250ms ease-out",
								style({
									opacity: 1,
									transform: "translateY(0px)",
								}),
							),
						),
					],
					{optional: true},
				),
				query(":leave", animate("0ms", style({opacity: 0})), {
					optional: true,
				}),
			]),
		]),
	],
	standalone: false,
})
export class SimAdminSettingsScrollEntriesConComponent<T> {
	T = Translations;

	@Input({required: true})
	public scrollEntries: T[];

	@Input({required: true})
	public getScrollEntryText: (scrollEntry: T) => string;

	@Input()
	public translationKeyForEmptySet: TranslationKey;

	@Input()
	public scrollContainerHeightInPX = 300;

	protected removeEntryEmitter = output<T>();

	removeEntry(scrollEntry: T) {
		if (scrollEntry) {
			this.removeEntryEmitter.emit(scrollEntry);
		}
	}
}
